export enum ChangeType {
    // Binario  // Decimal
    Ninguno = 0,
    // 000000  0
    DeliveryDay = 1 << 0,
    // 000001  1
    NeighborDelivery = 1 << 1,
    // 000010  2
    ServicePointDelivery = 1 << 2,
    // 000100  4
    GiveAnotherOption = 1 << 3,
    // 010000  8
    AlternativeAddressSolution = 1 << 4,
    // 010000  16
    FacilityPickupSolutionDHL = 1 << 5,
    // 010000  32
    SolutionSenderRecipient = 1 << 6,
    // 000000  64
    DeliveryDate = 1 << 7,
}

const objectTypeChange = (<any>ChangeType);
const nombres = new Map<number, string>();
objectTypeChange.nombres = nombres;

for (let elemento in objectTypeChange) {
  nombres.set(objectTypeChange[elemento], elemento)
}
